import { render } from "./Navigation.vue?vue&type=template&id=bde5de4a"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=bde5de4a&lang=css"

import exportComponent from "C:\\Users\\Szymon\\witryny\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__